import type { Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Field } from 'formik';
import { css } from '@emotion/react';

export const Card = styled.div`
  background-color: ${(props) => props.theme.color.light.default};
  border-radius: 10px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  margin: auto;
  max-width: 430px;
  width: 100%;
  padding: 30px;
  margin-top: -50px;
  margin-bottom: 200px;

  ${mediaQuery('phone')} {
    padding: 30px 10px;
  }
`;

export const Title = styled.div`
  ${responsiveFontSize(22, 1)}
  text-align: center;
  color: ${(props) => props.theme.color.blue.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  margin-bottom: 25px;
`;

export const TermsContainer = styled.span`
  color: ${(props) => props.theme.color.blue.default};
  a {
    color: ${(props) => props.theme.color.blue.default};
    font-weight: 600;
    text-decoration: underline;
  }
`;

export const InputWrapper = styled.div`
  max-width: 550px;
  margin: auto;
  position: relative;
  margin-top: 15px;
`;

export const CheckboxWrapper = styled.div`
  max-width: 550px;
  margin: auto;
  margin-top: 12px;
  text-align: left;
`;

export const Input = styled(Field)`
  padding: 0 15px;
  height: 40px;
  line-height: 40px;
  border-radius: 100px;
  width: 100%;
  font-size: 16px;
  border: 1px solid ${(props) => props.theme.color.light.shade};
  background: ${(props) => props.theme.color.light.default};
`;
export const inputRadioWrapperStyle = (theme: Theme) => css`
  color: ${theme.color.blue.default};
`;
